import { KOR_UNITS } from '../constants';

export function fmt(n: number): string {
  if (!isFinite(n)) return '∞';
  const a = Math.abs(n);
  const s = n < 0 ? '-' : '';
  for (const [unit, v] of KOR_UNITS) {
    if (a >= v) {
      const val = a / v;
      const txt =
        val >= 100
          ? Math.floor(val).toLocaleString('ko-KR')
          : val >= 10
          ? val.toFixed(1).replace(/\.0$/, '')
          : val.toFixed(2).replace(/\.?0+$/, '');
      return s + txt + unit;
    }
  }
  return s + Math.round(a).toLocaleString('ko-KR');
}

export function fmtTime(sec: number): string {
  if (sec < 60) return sec + '초';
  const m = Math.floor(sec / 60);
  if (m < 60) return m + '분';
  const h = Math.floor(m / 60);
  return h + '시간 ' + (m % 60) + '분';
}

// KST(UTC+9) 자정 기준 — Intl en-CA 포맷이 YYYY-MM-DD
export function todayStr(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Seoul' }).format(new Date());
}
